import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbsenteeismChartTypes } from 'app/modules/common/enums/absenteeism-chart-types';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CoordinatorKpi } from 'app/modules/coordinator/entities/coordinator-kpi';
import { CoordinatorStatisticsService } from 'app/modules/coordinator/services/coordinator-statistics.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { ChartPopupComponent } from '../chart-popup/chart-popup.component';

@Component({
    selector: 'app-kpi-grid',
    templateUrl: './kpi-grid.component.html',
    styleUrls: ['./kpi-grid.component.scss'],
    standalone: false
})
export class KpiGridComponent implements OnInit {

  public chartTypes = AbsenteeismChartTypes;
  public selectedCompanyId = 0;
  public isLoading = true;
  public kpiData: CoordinatorKpi;

  constructor(
    private empresaTreeViewService: EmpresaTreeViewService,
    private coordinatorStatisticsService: CoordinatorStatisticsService,
    private sharedService: SharedService,
    private dialog: MatDialog) { 
      this.registerTreeViewListener();
    }

  ngOnInit(): void {
    this.selectedCompanyId = JSON.parse(localStorage.getItem('Empresa'));
    if (this.selectedCompanyId > 0) {
      this.getKpiData();
    }
  }

  private registerTreeViewListener(): void {
    this.empresaTreeViewService.EmpId.subscribe(res => {
      this.selectedCompanyId = res;
      if (this.selectedCompanyId > 0) {
        this.getKpiData();
      }
    });
  }

  private getKpiData(): void {
    this.isLoading = true;
    this.coordinatorStatisticsService.GetKpimData(String(this.selectedCompanyId)).subscribe(res => {
      if (res.code === 0) {
        this.kpiData = res.result;
      } else {
        this.sharedService.ShowSnackBar('No se pudieron cargar los datos de kpi.');
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public openChartPopup(selectedType: AbsenteeismChartTypes): void {
    const modalRef = this.dialog.open(ChartPopupComponent, {
      width: '800px',
    });

    modalRef.componentInstance.selectedChartType = selectedType;
  }

}
